import React from 'react';
import { LoadedPage } from '~/components/jsx-helpers/loader-page';
import useLayoutContext from '~/contexts/layout';
import { ContentBlocks } from './blocks/ContentBlock';
import './flex-page.scss';
export const isFlexPage = (data) => {
    var _a;
    return typeof ((_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.type) === 'string' &&
        ['pages.FlexPage', 'pages.RootPage'].includes(data.meta.type);
};
function FlexPageBody({ data }) {
    return React.createElement(ContentBlocks, { data: data.body });
}
function warnAndUseDefault() {
    console.warn('No layout set for page');
    return 'default';
}
export function LayoutUsingData({ data, children }) {
    var _a;
    const { layoutParameters, setLayoutParameters } = useLayoutContext();
    const layoutName = ((_a = data.layout[0]) === null || _a === void 0 ? void 0 : _a.type) || warnAndUseDefault();
    if (layoutParameters.name !== layoutName) {
        setLayoutParameters({
            data,
            name: layoutName
        });
        return null;
    }
    return children;
}
export default function FlexPage({ data }) {
    return (React.createElement("main", { className: "flex-page page" },
        React.createElement(LoadedPage, { data: data, Child: FlexPageBody, doDocumentSetup: true, noCamelCase: true, props: {} })));
}
